import { UserManagment } from '@justomx/webview-commons'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { useEffect } from 'react'
import {
  I18nextProvider,
  initReactI18next,
  useTranslation
} from 'react-i18next'
import { RouterProvider } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { createGlobalStyle, StyleSheetManager } from 'styled-components'
import 'react-toastify/dist/ReactToastify.css'
import esGlobal from './i18n/es/global.json'
import brGlobal from './i18n/pt_BR/global.json'
import { router } from './pages/router'
import { isProduction } from './utils/environment'
import './analytics/analytics.utils'

import '@justomx/atlas-design-system/dist/style.css'

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    interpolation: { escapeValue: false },
    lng: 'es',
    resources: {
      es: { global: esGlobal },
      pt: { global: brGlobal }
    }
  })
  .catch((err) => {
    console.error(err)
  })

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    /* Atlas/Body Titles */
    font-style: normal;
    font-weight: 400;
  }
`

export const countryToLanguage: Record<string, string> = {
  mx: 'es',
  br: 'pt',
  pe: 'es'
}

const defaultLanguage = 'pt'

export function App() {
  console.info('Starting app! Is production? ', isProduction())
  const { i18n } = useTranslation('global')

  const setLang = (lang: string) => {
    i18n.changeLanguage(lang).catch((err) => {
      console.error(err)
    })
  }

  useEffect(() => {
    try {
      const loggedUser = UserManagment.getCurrentUser()
      let lang = defaultLanguage
      if (loggedUser?.country) {
        lang = countryToLanguage[loggedUser.country.toLowerCase()]
      }
      setLang(lang)
    } catch {
      setLang(defaultLanguage)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <I18nextProvider i18n={i18n}>
      <StyleSheetManager>
        <GlobalStyle />
        <div className="font-roboto flex flex-col w-full h-full gap-2 text-white">
          <RouterProvider router={router} />
        </div>
        <ToastContainer
          theme="dark"
          position="bottom-center"
          toastClassName="toastErrorClass"
        />
      </StyleSheetManager>
    </I18nextProvider>
  )
}
